import {
  FETCH_BY_TEMPLATE_ID__ERROR,
  FETCH_BY_TEMPLATE_ID__REQUEST,
  FETCH_BY_TEMPLATE_ID__SUCCESS,
} from "../../actionTypes";
import { TemplateMetadataSTORE, TemplatesActions } from "../../types";

const initialState: TemplateMetadataSTORE = {
  isFetching: false,
};

const singleTemplate = (
  state = initialState,
  action: TemplatesActions
): TemplateMetadataSTORE => {
  switch (action.type) {
    case FETCH_BY_TEMPLATE_ID__REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_BY_TEMPLATE_ID__SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      };

    case FETCH_BY_TEMPLATE_ID__ERROR:
      return {
        ...state,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default singleTemplate;
